export default __webpack_public_path__ + "a0375b655e9f0f83b181e8fe3050e41c.png";